module.exports = new __parcel__URL__("calender.ab2da95b.svg").toString();